export default "__VITE_ASSET__ujxkJyLy__"